import { render, staticRenderFns } from "./HddsPerCamera.vue?vue&type=template&id=64a28ee2"
import script from "./HddsPerCamera.vue?vue&type=script&lang=ts"
export * from "./HddsPerCamera.vue?vue&type=script&lang=ts"
import style0 from "./HddsPerCamera.vue?vue&type=style&index=0&id=64a28ee2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports